/**
 * Pure field-mapping logic for the line-item column-labeling panel.
 * No imports (no axios/CSS) so it is unit-testable under CRA's jest.
 *
 * data_type follows the chosen field automatically. "Something else…" leaves
 * the column unmapped (custom); a free-text custom name is deferred.
 */
export const FIELD_OPTIONS = [
  { key: 'sku',         label: 'Item code / SKU', mapped_field_key: 'sku',         data_type: 'text',     is_custom: false },
  { key: 'qty',         label: 'Quantity',        mapped_field_key: 'qty',         data_type: 'number',   is_custom: false },
  { key: 'description', label: 'Description',      mapped_field_key: 'description', data_type: 'text',     is_custom: false },
  { key: 'unit_price',  label: 'Price',            mapped_field_key: 'unit_price',  data_type: 'currency', is_custom: false },
  { key: 'total_price', label: 'Total',            mapped_field_key: 'total_price', data_type: 'currency', is_custom: false },
  { key: 'custom',      label: 'Something else…',   mapped_field_key: null,          data_type: 'text',     is_custom: true },
];

const CUSTOM_OPTION = FIELD_OPTIONS[FIELD_OPTIONS.length - 1];

// Which dropdown option represents a column's current mapping.
export function optionKeyForColumn(col) {
  if (col.is_custom || col.mapped_field_key == null) return 'custom';
  const found = FIELD_OPTIONS.find(o => o.mapped_field_key === col.mapped_field_key);
  return found ? found.key : 'custom';
}

// Apply a selected option to a column, preserving column_order + bands + label.
export function applyFieldSelection(col, optionKey) {
  const opt = FIELD_OPTIONS.find(o => o.key === optionKey) || CUSTOM_OPTION;
  return { ...col, mapped_field_key: opt.mapped_field_key, data_type: opt.data_type, is_custom: opt.is_custom };
}

/**
 * Whether to show the "account gate is off" warning. The tenant gate
 * (capture_settings.extract_line_items) is what actually decides whether
 * line-item extraction runs — independent of these mapped columns. Fail OPEN:
 * only warn when we have a settings object whose flag is explicitly false; a
 * missing/errored settings read returns false (no warning, never blocks).
 */
export function shouldShowGateWarning(settings) {
  return !!settings && settings.extract_line_items === false;
}
